import React, {useEffect} from 'react';
import root from 'window-or-global';
import {withRouter, RouteComponentProps} from 'react-router-dom';

const SSO_LOGIN = 'epicSsoLogin';

export interface RefreshOnSessionChangeProps extends RouteComponentProps {
    isLoggedIn: boolean;
}

const RefreshOnSessionChange: React.FC<RefreshOnSessionChangeProps> = ({
    children,
    isLoggedIn = false
}) => {
    useEffect(() => {
        const loginListener = event => {
            // refresh current page if login Status has been changed
            if (event.key === SSO_LOGIN && event.newValue !== event.oldValue) {
                let loggedInValue = event.newValue;
                // Fix for IE storing values as strings rather than bools
                if (typeof loggedInValue === 'string') {
                    loggedInValue = loggedInValue === 'true';
                }
                // Fix for IE this is always fired immediately upon loading the page so only act on it
                // if the value is not what we expect
                if (isLoggedIn !== loggedInValue) {
                    setImmediate(root.location.reload.bind(root.location));
                }
            }
        };

        const isLocalStorageAvailable = () => {
            let isAvailable = true;
            try {
                root.localStorage.setItem('test', 'test');
                root.localStorage.removeItem('test');
            } catch (e) {
                isAvailable = false;
            }
            return isAvailable;
        };

        const initLoginFlag = () => {
            if (typeof isLoggedIn === 'boolean') {
                root.localStorage[SSO_LOGIN] = isLoggedIn;
            }
        };

        if (typeof root.addEventListener === 'function' && isLocalStorageAvailable()) {
            initLoginFlag();
            root.addEventListener('storage', loginListener);
        }

        return () => {
            if (typeof root.removeEventListener === 'function' && isLocalStorageAvailable()) {
                root.removeEventListener('storage', loginListener);
            }
        };
    }, []);

    return <>{children}</>;
};

export default withRouter(RefreshOnSessionChange);
